import {defineStore} from 'pinia'
import {type BillingNs, CommonNs} from "@shared/types";
import {BillingApi} from "@/api";


export const useBillingStore = defineStore("billing", {
  state: () => ({
    subscriptionInfo: {} as BillingNs.SubscriptionInfo
  }),
  getters: {
    getSubscriptionInfo: (state) => state.subscriptionInfo
  },
  actions: {
    async loadSubscriptionInfo(workspaceId: string): Promise<BillingNs.SubscriptionInfo> {
      return BillingApi.getSubscriptionInfo({
        workspaceId
      }).then((response: BillingNs.SubscriptionInfo) => {
        this.subscriptionInfo = response;
        return response
      })
    },
    async loadCustomerCards(): Promise<BillingNs.CardInfo[]> {
      return BillingApi.getCustomerCards()
      .then((customerCards: BillingNs.CardInfo[]) => {
        return customerCards
      })
    },

    async loadBillingAddress(custId: string): Promise<BillingNs.BillingAddress[]> {
      return BillingApi.getBillingAddresses(custId)
      .then((billingAddresses: BillingNs.BillingAddress[]) => {
        return billingAddresses
      })
    },

    async deleteBillingAddress(custId: string): Promise<CommonNs.AnyResponse> {
      return BillingApi.deleteBillingAddress(custId)
      .then((response) => response)
    },

    async deletePaymentMethod(
        cardId: string
    ): Promise<CommonNs.AnyResponse> {
      return BillingApi.deletePaymentMethod(cardId)
      .then((response) => response)
    },

    async loadSubscriptionInfos(): Promise<BillingNs.SubscriptionInfo[]> {
      return BillingApi.getSubscriptionInfos()
      .then((subscriptionInfos: BillingNs.SubscriptionInfo[]) => {
        return subscriptionInfos
      })
    },

    async updateBillingAddress(
        payload: BillingNs.BillingAddress
    ): Promise<CommonNs.AnyResponse> {
      return BillingApi.updateBillingAddress(payload)
      .then((response: CommonNs.AnyResponse) => response)
    },

    async updatePaymentMethod(
        payload: BillingNs.PaymentMethod
    ): Promise<CommonNs.AnyResponse> {
      return BillingApi.updatePaymentMethod(payload)
      .then((response: CommonNs.AnyResponse) => response)
    }
  }
})
